import { 
  Container, 
  Typography, 
  Grid, 
  Box, 
  Card, 
  CardContent, 
  CardMedia,
  Button,
  Divider
} from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(4),
  position: 'relative',
  '&:after': {
    content: '""',
    display: 'block',
    width: 80,
    height: 3,
    backgroundColor: '#e30613', 
    position: 'absolute',
    bottom: -10,
    left: 0,
  },
}));

const AboutUs = () => {
  return (
    <Box sx={{ backgroundColor: '#f8f9fa', py: 6 }}>
      <Container maxWidth="lg">
        
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          About Us
        </Typography>
        <Divider sx={{ mb: 6 }} />

        <Grid container spacing={4} mb={8}>
          <Grid item xs={12} md={6}>
            <SectionTitle variant="h4">
              Our Story
            </SectionTitle>
            <Typography paragraph>
              Del Toro Insurance has been serving Florida communities since 1995. What began as a small family-owned agency has grown into one of the most trusted insurance providers in Florida, while still maintaining our commitment to personalized service.
            </Typography>
            <Typography paragraph>
              Our team of experienced professionals is dedicated to helping you find the right insurance solutions to protect what matters most to you, your family, and your business.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card elevation={3}>
              <CardMedia
                component="img"
                height="300"
                image="/api/placeholder/600/400"
                alt="Del Toro Insurance Office"
              />
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={4} mb={8}>
          <Grid item xs={12}>
            <SectionTitle variant="h4">
              Our Mission & Values
            </SectionTitle>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent>
                <Typography variant="h5" component="h3" gutterBottom fontWeight="bold" color="primary">
                  Trust
                </Typography>
                <Typography>
                  We build lasting relationships with our clients based on transparency and integrity in every interaction.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent>
                <Typography variant="h5" component="h3" gutterBottom fontWeight="bold" color="primary">
                  Excellence
                </Typography>
                <Typography>
                  We strive to deliver exceptional service and insurance solutions tailored to each client's unique needs.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent>
                <Typography variant="h5" component="h3" gutterBottom fontWeight="bold" color="primary">
                  Community
                </Typography>
                <Typography>
                  We are deeply committed to the communities we serve and actively contribute to their well-being.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        
        <Grid container spacing={4} mb={8}>
          <Grid item xs={12}>
            <SectionTitle variant="h4">
              Our Services
            </SectionTitle>
            <Typography paragraph>
              At Del Toro Insurance, we offer a comprehensive range of insurance products to meet your personal and business needs:
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" component="h3" gutterBottom fontWeight="bold">
              Personal Insurance
            </Typography>
            <Typography paragraph>
              • Auto Insurance<br />
              • Homeowners Insurance<br />
              • Renters Insurance<br />
              • Motorcycle Insurance<br />
              • Boat Insurance<br />
              • Personal Umbrella Policies
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" component="h3" gutterBottom fontWeight="bold">
              Business Insurance
            </Typography>
            <Typography paragraph>
              • Commercial Property Insurance<br />
              • General Liability Insurance<br />
              • Workers' Compensation<br />
              • Business Owners Policy (BOP)<br />
              • Commercial Auto Insurance<br />
              • Professional Liability Insurance
            </Typography>
          </Grid>
        </Grid>
        
        <Grid container spacing={4} mb={8}>
          <Grid item xs={12}>
            <SectionTitle variant="h4">
              Our Leadership Team
            </SectionTitle>
          </Grid>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item}>
              <Card>
                <CardMedia
                  component="img"
                  height="200"
                  image={`/api/placeholder/300/300`}
                  alt={`Team Member ${item}`}
                />
                <CardContent>
                  <Typography variant="h6" component="h3" gutterBottom>
                    Executive Name
                  </Typography>
                  <Typography color="textSecondary" gutterBottom>
                    Position Title
                  </Typography>
                  <Typography variant="body2">
                    Brief bio about the team member and their expertise in the insurance industry.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        
        <Box textAlign="center" py={4}>
          <Typography variant="h5" gutterBottom>
            Ready to find the right insurance coverage?
          </Typography>
          <Button 
            variant="contained" 
            size="large" 
            color="primary" 
            sx={{ 
              mt: 2, 
              bgcolor: '#e30613', 
              '&:hover': { bgcolor: '#b50000' }, 
              px: 4, 
              py: 1 
            }}
          >
            Contact Us Today
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutUs;